{
    "absence": {
        "balance_history": {
            "empty_state": "",
            "filter_all_groups": "",
            "get_absence_sheet": "",
            "title": ""
        },
        "details": {
            "action_approve_withdrawal": "",
            "action_cancel": "",
            "action_deny_withdrawal": "",
            "action_request": "",
            "change_requested": "",
            "events_on": "",
            "field_dates": "",
            "field_duration": "",
            "field_hours": "",
            "field_notes_hr": "",
            "field_reason": "",
            "field_vacation_balance": "",
            "locked_by": "{{name}} modifie actuellement cet employé.",
            "locked_message": "",
            "remove_dialog_body": "",
            "title": "",
            "withdrawal_asked_on": "",
            "withdrawal_awaiting": "",
            "withdrawal_requested": ""
        },
        "duration": {
            "day_one": "",
            "day_many": "",
            "day_other": "",
            "hour_one": "",
            "hour_many": "",
            "hour_other": ""
        },
        "legend": {
            "status_pending": "",
            "status_tentative": "",
            "status_unspecified": "",
            "title": ""
        },
        "page_header": {
            "group_civil_days": "",
            "group_family_leave": "",
            "group_health_leave": "",
            "group_vacation": "",
            "tooltip_schedule": ""
        },
        "page_title": "",
        "schedule": {
            "title": "",
            "withdraw_title": ""
        },
        "timeline": {
            "days_off_left": "",
            "nav_next_day": "",
            "nav_next_month": "",
            "nav_next_week": "",
            "nav_previous_day": "",
            "nav_previous_month": "",
            "nav_previous_week": "",
            "search_members": "",
            "view_day": "",
            "view_month": ""
        }
    },
    "alerts": {
        "alert_image_alt": "",
        "collapse_alert_row_tooltip": "",
        "create_alert": "",
        "creator": "",
        "date_time": "",
        "description": "",
        "edit_alert_tooltip": "",
        "expand_alert_row_tooltip": "",
        "finish_current_edit_first": "",
        "images_left_one": "",
        "images_left_many": "",
        "images_left_other": "",
        "new_alert_notification": "",
        "open_image_preview": "",
        "opened": "",
        "owned_cases": "",
        "page_title": "",
        "person_in_charge": "",
        "pic": "",
        "reassign": "",
        "reassign_alert": "",
        "resolution_notes": "",
        "resolve_alert": "",
        "resolved": "",
        "show_image": "",
        "supervised_cases": "",
        "title": "",
        "total_this_year": "",
        "up_to_5_files": "",
        "validation_description_required": "",
        "validation_images_max": "",
        "validation_person_in_charge_required": "",
        "validation_type_required": ""
    },
    "auth": {
        "authenticator_qr_alt": "",
        "back_to_login": "",
        "challenge_missing": "",
        "change_password_button_title": "",
        "default_enrollment_notice": "",
        "email_label": "",
        "enable_two_factor_authentication": "",
        "enrollment_link_invalid_or_expired": "",
        "enrollment_token_missing": "",
        "forgot_password_link": "",
        "login": "",
        "manual_key": "",
        "manual_key_label": "",
        "missing_challenge_token": "",
        "new_password_label": "",
        "otp_label": "",
        "password": "",
        "password_changed_successfully": "",
        "reset_confirm_hint": "",
        "reset_password_title": "",
        "reset_request_2fa_hint": "",
        "reset_request_enter_email": "",
        "reset_request_success": "",
        "scan_qr_or_use_manual_key": "",
        "send_reset_link": "",
        "set_new_password_button": "",
        "two_factor_authentication": "",
        "use_another_account": "",
        "validation": {
            "email_invalid": "",
            "email_required": "",
            "otp_invalid": "",
            "otp_required": "",
            "password_min": "",
            "password_required": ""
        },
        "verification_code_label": "",
        "verify_and_continue": "",
        "verify_otp_code_button": ""
    },
    "blocker": {
        "cancel_button": "",
        "confirm_button": "",
        "text": "",
        "title": ""
    },
    "calendar": {
        "preset": {
            "all_dates": "",
            "last_month": "",
            "last_week": "",
            "last_year": "",
            "this_month": "",
            "this_week": "",
            "this_year": ""
        }
    },
    "choices_select": {
        "empty": ""
    },
    "common": {
        "active": "",
        "add": "",
        "all": "",
        "apply_button_title": "",
        "approve": "",
        "balance_history": "",
        "cancel": "",
        "clear_all": "",
        "close": "",
        "compare": "",
        "confirm": "",
        "copy_button": "",
        "copy_button_copied": "",
        "copy_button_error": "",
        "date": "",
        "delete": "",
        "deny": "",
        "download": "",
        "drag": "",
        "edit": "",
        "end_date": "",
        "filter": "",
        "from": "",
        "from_label": "",
        "full_screen": "",
        "inactive": "",
        "internal_phone_book": "",
        "legend": "",
        "mail": "",
        "next": "",
        "none": "",
        "not_saved": "",
        "notes": "",
        "previous": "",
        "quick_dial": "",
        "reference": "",
        "required_field": "",
        "reset_filters": "",
        "save": "",
        "search": "",
        "set": "",
        "settings": "",
        "show_more": "",
        "start_date": "",
        "status": "",
        "tasks": "",
        "to": "",
        "to_label": "",
        "today": "",
        "tomorrow": "",
        "try_again": "",
        "type": "",
        "type_to_search": "",
        "update": ""
    },
    "dashboard": {
        "settings": ""
    },
    "fleet": {
        "add_vehicle": "",
        "assigned_driver": "",
        "capacity": "",
        "chassis": "",
        "comment": "",
        "commissioning_date": "",
        "consumption_count_one": "",
        "consumption_count_many": "",
        "consumption_count_other": "",
        "cost": "",
        "cost_currency": "",
        "cost_per_km": "",
        "create_vehicle": "",
        "current_swap_body": "",
        "data": "",
        "decommissioning_date": "",
        "dimensions": "",
        "dispatchable": "",
        "distance_year": "",
        "driven_year": "",
        "empty_weight": "",
        "fuel": "",
        "fuel_l": "",
        "fuel_used_year": "",
        "general": "",
        "gross_weight": "",
        "group_load_error": "",
        "height": "",
        "hydraulic_platform": "",
        "import_vehicles": "",
        "length": "",
        "license": "",
        "load_error": "",
        "location": "",
        "maintenance_count_one": "",
        "maintenance_count_many": "",
        "maintenance_count_other": "",
        "make": "",
        "master_number": "",
        "model": "",
        "not_saved": "",
        "number": "",
        "operational": "",
        "owner_branch": "",
        "page_title": "",
        "payload": "",
        "photo": "",
        "provider": "",
        "purchase_price": "",
        "required_qualification": "",
        "select_driver": "",
        "standard_trailer": "",
        "total": "",
        "type": "",
        "user_branch": "",
        "validation_commissioning_date_required": "",
        "validation_cost_comment_max": "",
        "validation_cost_cost_number": "",
        "validation_cost_date_required": "",
        "validation_cost_end_date_before_date": "",
        "validation_cost_end_date_required": "",
        "validation_cost_fuel_number": "",
        "validation_cost_km_integer": "",
        "validation_cost_provider_required": "",
        "validation_cost_type_required": "",
        "validation_decommissioning_date": "",
        "validation_make_required": "",
        "validation_master_number_required": "",
        "validation_model_required": "",
        "validation_number_required": "",
        "validation_purchase_price_number": "",
        "validation_purchase_price_required": "",
        "validation_required": "",
        "vehicle": "",
        "vehicle_detail": "",
        "vehicle_detail_load_error": "",
        "vehicle_name": "",
        "view_vehicle": "",
        "width": "",
        "year": ""
    },
    "landing": {
        "company_updates": {
            "title": ""
        },
        "greeting": "",
        "page_header": {
            "anniversaries": "",
            "birthdays": "",
            "office_closure": "",
            "online": ""
        },
        "system_whiteboard": {
            "title": ""
        },
        "upcoming_events": {
            "title": ""
        },
        "user_board": {
            "title": ""
        }
    },
    "layout": {
        "sidebar": {
            "collapse": "",
            "expand": ""
        }
    },
    "not_found": {
        "cta_authenticated": "",
        "description": "",
        "title": ""
    },
    "permissions": {
        "users": {
            "kc_view_user_list": ""
        }
    },
    "phone_book": {
        "online": ""
    },
    "profile": {
        "page_title": ""
    },
    "reports": {
        "export": {
            "absence": "Absence",
            "action": "Exporter",
            "all_data": "Toutes les données",
            "failed": "Le rapport n’a pas pu être généré. Veuillez réessayer.",
            "overtime": "Heures supplémentaires",
            "period": "Période",
            "title": "Exporter"
        }
    },
    "settings": {
        "language": {
            "english": "",
            "german": "",
            "help": "",
            "success": "",
            "title": ""
        },
        "page_title": "",
        "password": {
            "confirm_password": "",
            "otp_code": "",
            "otp_description": "",
            "reset_password": "",
            "success": "",
            "title": "",
            "validation": {
                "confirm_mismatch": "",
                "confirm_required": "",
                "new_required": "",
                "requirements": ""
            },
            "your_otp_code": ""
        },
        "security_confirmation": {
            "description": "",
            "title": ""
        },
        "two_factor": {
            "cancel_failed": "",
            "reset_action": "",
            "set_up_action": "",
            "status_active": "",
            "status_label": "",
            "status_setup_required": "",
            "title": "",
            "view_code_action": ""
        }
    },
    "sidebar": {
        "absence": "",
        "admin": "",
        "clients": "",
        "dashboard": "",
        "fleet": "",
        "home": "",
        "logout": "",
        "team": "",
        "user_management": ""
    },
    "smart_date": {
        "next_years": "",
        "previous_years": ""
    },
    "tasks": {
        "collapse_task_row_tooltip": "",
        "complete_task": "",
        "completed": "",
        "completed_task": "",
        "copy_task": "",
        "create_new_task": "",
        "create_task": "",
        "creator": "",
        "due_date": "",
        "due_date_short": "",
        "due_tasks": "",
        "edit_task_tooltip": "",
        "estimated": "",
        "expand_task_row_tooltip": "",
        "filter_assigned_to_me": "",
        "filter_label": "",
        "filter_overdue": "",
        "filter_ownership_label": "",
        "filter_raised_by_me": "",
        "filter_upcoming": "",
        "finish_current_edit_first": "",
        "internal_notes": "",
        "load_failed": "",
        "mark_prioritized": "",
        "no_open_tasks": "",
        "no_overdue_tasks": "",
        "no_upcoming_tasks": "",
        "open_tasks": "",
        "overdue_tasks": "",
        "person_in_charge": "",
        "pic": "",
        "priority_abbreviated": "",
        "private": "",
        "private_task_tooltip": "",
        "reassign": "",
        "reassign_task": "",
        "reopen_task": "",
        "starred": "",
        "task": "",
        "task_description": "",
        "unmark_prioritized": "",
        "unstarred": "",
        "validation_due_date_required": "",
        "validation_person_in_charge_required": "",
        "validation_task_description_max": "",
        "validation_task_description_required": "",
        "validation_type_required": ""
    },
    "upcoming_events": {
        "filter": {
            "birthdays": "",
            "holidays": "",
            "vacations": ""
        },
        "type": {
            "birthday": "",
            "holiday": "",
            "vacation": ""
        }
    },
    "user_management": {
        "page_title": "",
        "table": {
            "branch": "",
            "initials": "",
            "job_title": "",
            "manager": "",
            "name": "",
            "rank": "",
            "salary_percentage": ""
        }
    },
    "users": {
        "add": {
            "go_to_next_step": "",
            "go_to_previous_step": "",
            "search_user": "",
            "user_reference_for_autocompletion": "",
            "user_summary_title": ""
        },
        "add_emergency_contact": "",
        "add_new_user": "",
        "add_stepper": {
            "contacts_description": "",
            "emergency_contacts_description": "",
            "emergency_contacts_title": "",
            "location_description": "",
            "personal_description": "",
            "personal_title": "",
            "professional_description": "",
            "professional_title": "",
            "review_description": "",
            "review_title": ""
        },
        "add_user": {
            "page_title": ""
        },
        "birthdate": "",
        "branch": "",
        "career_development_title": "",
        "compare": {
            "page_title": "",
            "permissions": "",
            "select_user": "",
            "users": ""
        },
        "contacts": {
            "email": "",
            "mobile": "",
            "name": "",
            "phone": "",
            "private_email": "",
            "private_mobile": "",
            "private_phone": "",
            "title": ""
        },
        "contacts_title": "",
        "department": "",
        "deputy": "",
        "edit": {
            "page_title": ""
        },
        "email": "",
        "emergency_contact_indexed": "",
        "emergency_contacts_title": "",
        "events": "",
        "family_name": "",
        "first_name": "",
        "hr": "",
        "initials": "",
        "location": {
            "address": "",
            "address_plural": "",
            "city": "",
            "country": "",
            "country_placeholder": "",
            "postal_code": "",
            "postcode": "",
            "title": ""
        },
        "location_title": "",
        "manager": "",
        "new_user": "",
        "not_saved": "",
        "page_title": "",
        "personal_information_title": "",
        "photo": "",
        "professional_information_branch": "",
        "professional_information_branch_placeholder": "",
        "professional_information_department": "",
        "professional_information_department_placeholder": "",
        "professional_information_deputy": "",
        "professional_information_deputy_placeholder": "",
        "professional_information_direct_manager": "",
        "professional_information_employing_company": "",
        "professional_information_hourly_salary": "",
        "professional_information_hr": "",
        "professional_information_hr_placeholder": "",
        "professional_information_job_title": "",
        "professional_information_job_title_placeholder": "",
        "professional_information_manager_placeholder": "",
        "professional_information_manager_required": "",
        "professional_information_monthly_salary": "",
        "professional_information_percentage": "",
        "professional_information_rank": "",
        "professional_information_salary": "",
        "professional_information_salary_type": "",
        "professional_information_salary_type_hourly": "",
        "professional_information_salary_type_monthly": "",
        "professional_information_self_managing": "",
        "professional_information_team": "",
        "professional_information_team_placeholder": "",
        "professional_information_title": "",
        "qualification": "",
        "qualification_approved": "",
        "qualification_duplicate": "",
        "qualification_update_inactive_confirm": "",
        "qualification_update_inactive_title": "",
        "qualification_updated": "",
        "relation": {
            "friend": "",
            "other": "",
            "parent": "",
            "partner": "",
            "sibling": ""
        },
        "relation_title": "",
        "remove_emergency_contact": "",
        "save_all_tooltip": "",
        "saved_successfully": "",
        "schedule_add_interval": "",
        "schedule_apply_to_all_days": "",
        "schedule_apply_to_all_working_days": "",
        "schedule_approve_changed": "",
        "schedule_approve_past_confirm": "",
        "schedule_approve_past_title": "",
        "schedule_approve_success": "",
        "schedule_approved": "",
        "schedule_current": "",
        "schedule_day_friday": "",
        "schedule_day_monday": "",
        "schedule_day_saturday": "",
        "schedule_day_sunday": "",
        "schedule_day_thursday": "",
        "schedule_day_tuesday": "",
        "schedule_day_wednesday": "",
        "schedule_delete_future": "",
        "schedule_delete_interval": "",
        "schedule_future": "",
        "schedule_hours_per_week": "",
        "schedule_pending": "",
        "schedule_total": "",
        "schedule_unchanged": "",
        "schedule_work_schedule": "",
        "security_language_title": "",
        "security_title": "",
        "send_invite": "",
        "signature": "",
        "summary": {
            "edit_section": "",
            "fill_in_section": ""
        },
        "team": "",
        "title": "",
        "user_label": "",
        "vacation_credit_date": "",
        "vacation_credit_days": "",
        "vacation_credit_explanation": "",
        "vacation_credit_load_failed": "",
        "vacation_credit_system_generated": "",
        "vacation_credit_title": "",
        "validation": {
            "birthdate_in_future": "",
            "birthdate_invalid": "",
            "birthdate_required": "",
            "birthdate_too_early": "",
            "career_end_date_after_start": "",
            "career_hourly_salary_positive_decimal": "",
            "career_monthly_salary_positive_integer": "",
            "career_percentage_range": "",
            "career_start_date_required": "",
            "date_invalid": "",
            "email_invalid": "",
            "email_required": "",
            "family_name_required": "",
            "first_name_required": "",
            "hourly_salary_decimals": "",
            "hourly_salary_max": "",
            "hourly_salary_positive": "",
            "hourly_salary_required": "",
            "initials_max": "",
            "initials_required": "",
            "job_title_required": "",
            "mobile_invalid": "",
            "monthly_salary_integer": "",
            "monthly_salary_positive": "",
            "monthly_salary_required": "",
            "number_invalid": "",
            "phone_invalid": "",
            "phone_required": "",
            "qualification_assignment_duplicate": "",
            "qualification_from_required": "",
            "qualification_required": "",
            "qualification_to_before_from": "",
            "rank_required": "",
            "salary_end_date_before_start": "",
            "salary_intervals_overlap": "",
            "salary_percentage_integer": "",
            "salary_percentage_range": "",
            "salary_percentage_required": "",
            "salary_start_date_required": "",
            "salary_type_required": "",
            "schedule_end_after_start": "",
            "schedule_intervals_overlap": "",
            "schedule_start_date_invalid": "",
            "schedule_time_required": "",
            "vacation_credit_date_required": "",
            "vacation_credit_date_reserved": "",
            "vacation_credit_days_invalid": "",
            "vacation_credit_explanation_max": ""
        },
        "view_user_profile_details_double_click_row": "",
        "warnings": {
            "evaluate_failed": ""
        }
    },
    "version": {
        "update_available": {
            "action": "",
            "description": "",
            "title": ""
        }
    },
    "whiteboard": {
        "accept": "",
        "accepted": "",
        "confirmed": "",
        "expiration_date": "",
        "form": {
            "all_users": "",
            "create_company_title": "",
            "create_system_title": "",
            "create_user_title": "",
            "created_successfully": "",
            "delete_dialog_text": "",
            "delete_dialog_title": "",
            "deleted_successfully": "",
            "description": "",
            "employing_company": "",
            "expiration_date": "",
            "individual_user": "",
            "location": "",
            "no_team": "",
            "recipients": "",
            "title": "",
            "update_company_title": "",
            "update_system_title": "",
            "update_user_title": "",
            "updated_successfully": ""
        },
        "hide_confirmed": "",
        "show_confirmed": ""
    }
}